import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import { login } from "../actions/auth";

class PassphraseRecoveryconfirm extends Component {
  state = { fillmnemonic: [], values: {}, loading: false };

  componentDidMount() {
    const words = this.props.mnemonic.split(" ");
    const positions = _.sampleSize(words.map((value, index) => ({ value, index })), 5);
    this.setState({ fillmnemonic: _.orderBy(positions, ["index"], ["asc"]) });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const complete = this.state.fillmnemonic.every((word, index) =>
      this.state.values[index] && word.value.trim() === this.state.values[index].trim().toLowerCase()
    );

    if (!complete) {
      toast.error("One or more words do not match. Check the numbered positions and try again.");
      return;
    }

    this.setState({ loading: true });
    const { dispatch, history, mnemonic } = this.props;
    dispatch(login(mnemonic))
      .then((resp) => {
        if (resp.code === 100) {
          history.push("/dashboard/VSOL");
          window.location.reload();
        } else {
          toast.error(resp.msg || "Unable to open the new wallet.");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        toast.error("Unable to open the new wallet.");
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <section className="nova-create-card nova-confirm-card" aria-labelledby="confirm-title">
        <div className="nova-create-title">
          <span className="nova-create-icon" aria-hidden="true">✓</span>
          <div>
            <span className="nova-eyebrow">One last check</span>
            <h1 id="confirm-title">Confirm your backup</h1>
          </div>
        </div>
        <p className="nova-create-lead">Enter the five requested words from your recovery phrase. This confirms that your backup is complete.</p>

        <form onSubmit={this.handleSubmit}>
          <div className="nova-confirm-grid">
            {this.state.fillmnemonic.map((data, index) => (
              <label className="nova-confirm-field" key={data.index} htmlFor={"word-" + data.index}>
                <span>Word <b>#{data.index + 1}</b></span>
                <input id={"word-" + data.index} type="text" autoComplete="off" autoCapitalize="none" spellCheck="false"
                  value={this.state.values[index] || ""}
                  onChange={(event) => this.setState({ values: { ...this.state.values, [index]: event.target.value } })}
                  placeholder="Enter word" />
              </label>
            ))}
          </div>

          <div className="nova-create-actions nova-confirm-actions">
            <button className="btn nova-copy-button" type="button" onClick={this.props.onBack}>← View words again</button>
            <button className="btn nova-primary-button" type="submit" disabled={this.state.loading}>
              {this.state.loading ? <><span className="spinner-border spinner-border-sm" aria-hidden="true"></span> Opening wallet…</> : <>Confirm and open wallet <span aria-hidden="true">→</span></>}
            </button>
          </div>
        </form>
        <p className="nova-offline-note"><span aria-hidden="true">●</span> Your phrase remains the key to this wallet. Keep it private.</p>
      </section>
    );
  }
}

export default connect()(PassphraseRecoveryconfirm);
